import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import Image from 'next/image';
import { type ReactNode } from 'react';
import AddPhotoIcon from '../svgs/add-photo-icon';
import styles from './profile-photo.module.scss';
export enum ProfilePhotoSize {
  Large = 'large',
  Normal = 'normal',
  XSmall = 'xsmall',
}
export type ProfilePhotoContentType = {
  photoCropAriaLiveText?: string;
  pictureDescription: string;
};
export type ProfilePhotoProps = {
  actionLabelText?: string;
  cmsContent: ProfilePhotoContentType;
  hasBorder?: boolean;
  hasHoverOverlay?: boolean;
  imageSrc: string | undefined;
  isFluid?: boolean;
  placeholderComponent?: ReactNode;
  size?: ProfilePhotoSize;
};
const PARENT_CLASSNAME = 'profile-photo';
export const ProfilePhoto = t0 => {
  const $ = _c(24);
  const {
    actionLabelText,
    cmsContent,
    hasBorder: t1,
    hasHoverOverlay,
    imageSrc,
    isFluid: t2,
    placeholderComponent,
    size: t3
  } = t0;
  const hasBorder = t1 === undefined ? true : t1;
  const isFluid = t2 === undefined ? false : t2;
  const size = t3 === undefined ? ProfilePhotoSize.Normal : t3;
  const imageAltText = hasHoverOverlay ? `${cmsContent.pictureDescription}. ${actionLabelText}` : cmsContent.pictureDescription;
  let t4;
  if ($[0] !== hasHoverOverlay) {
    t4 = classNames(styles[`${PARENT_CLASSNAME}__content`], {
      [styles[`${PARENT_CLASSNAME}__content--hover`]]: hasHoverOverlay
    });
    $[0] = hasHoverOverlay;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <AddPhotoIcon className={styles[`${PARENT_CLASSNAME}__icon`]} />;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== actionLabelText) {
    t6 = <span>{actionLabelText}</span>;
    $[3] = actionLabelText;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== hasHoverOverlay || $[6] !== t4 || $[7] !== t6) {
    t7 = <div aria-hidden={hasHoverOverlay} className={t4} data-testid="photo-placeholder-overlay">{t5}{t6}</div>;
    $[5] = hasHoverOverlay;
    $[6] = t4;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const renderOverlay = t7;
  const t8 = size === ProfilePhotoSize.Large;
  const t9 = size === ProfilePhotoSize.XSmall;
  let t10;
  if ($[9] !== hasBorder || $[10] !== isFluid || $[11] !== t8 || $[12] !== t9) {
    t10 = classNames(styles[`${PARENT_CLASSNAME}`], {
      [styles[`${PARENT_CLASSNAME}--has-border`]]: hasBorder,
      [styles[`${PARENT_CLASSNAME}--is-fluid`]]: isFluid,
      [styles[`${PARENT_CLASSNAME}--large`]]: t8,
      [styles[`${PARENT_CLASSNAME}--xsmall`]]: t9
    });
    $[9] = hasBorder;
    $[10] = isFluid;
    $[11] = t8;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== hasHoverOverlay || $[15] !== imageAltText || $[16] !== imageSrc || $[17] !== placeholderComponent || $[18] !== renderOverlay || $[19] !== size) {
    t11 = imageSrc ? <><div className={styles[`${PARENT_CLASSNAME}__content`]} data-testid="photo-placeholder-content"><Image alt={imageAltText} className={styles[`${PARENT_CLASSNAME}__image`]} data-testid="photo-placeholder-image" fetchPriority="high" height={size === ProfilePhotoSize.Large ? 260 : 172} loading="eager" preload={true} src={imageSrc} width={size === ProfilePhotoSize.Large ? 260 : 172} /></div>{hasHoverOverlay && renderOverlay}</> : placeholderComponent && !hasHoverOverlay ? placeholderComponent : renderOverlay;
    $[14] = hasHoverOverlay;
    $[15] = imageAltText;
    $[16] = imageSrc;
    $[17] = placeholderComponent;
    $[18] = renderOverlay;
    $[19] = size;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t11) {
    t12 = <div className={t10}>{t11}</div>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
};